import styled from "styled-components";

export const MobileAccountBoxBlockPlSkeleton2Styled = styled.div`
    height: 30px;
    width: 60px;
    border-radius: 12px;
    padding: 6px 12px;
    font-weight: 600;
    display: inline-block;
`;
